import { Component, input, output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { IconComponent } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-news-unread-counter',
  templateUrl: './news-unread-counter.component.html',
  styleUrls: ['./news-unread-counter.component.scss'],
  imports: [IconComponent, ApmTranslatePipe, MatTooltip],
})
export class NewsUnreadCounterComponent {
  readonly unreadNews = input<number>();

  badgeClick = output<void>();

  onBadgeClickHandler(): void {
    this.badgeClick.emit();
  }
}
